import { CampaignCountdown as UICampaignCountdown } from '@wegic/ui'
import '@wegic/ui/dist/components/CampaignCountdown/index.css';;
import { useEffect, useRef, useState } from 'react';

import { getCampaignCountdownUnits } from './helper';

interface CampaignCountdownProps {
  targetTimestamp: number;
  className?: string;
  labelColor?: string;
  separatorColor?: string;
  onEnd?: () => void;
}

export default function CampaignCountdown({
  targetTimestamp,
  className = '',
  labelColor = '#fff',
  separatorColor,
  onEnd,
}: CampaignCountdownProps) {
  const [units, setUnits] = useState(() => getCampaignCountdownUnits(targetTimestamp).units);
  const onEndRef = useRef(onEnd);
  const endedRef = useRef(false);

  useEffect(() => {
    onEndRef.current = onEnd;
  }, [onEnd]);

  useEffect(() => {
    endedRef.current = false;

    const update = () => {
      const next = getCampaignCountdownUnits(targetTimestamp);
      setUnits(next.units);

      if (next.isEnded && !endedRef.current) {
        endedRef.current = true;
        onEndRef.current?.();
      }
    };

    update();
    const timer = window.setInterval(update, 1000);

    return () => window.clearInterval(timer);
  }, [targetTimestamp]);

  return (
    <UICampaignCountdown
      units={units}
      labelColor={labelColor}
      separatorColor={separatorColor}
      className={className || undefined}
    />
  );
}
